import { create } from 'zustand';
import type { Admin } from '../types';
import { apiService } from '../services/api';

interface AuthState {
  admin: Admin | null;
  token: string | null;
  isAuthenticated: boolean;
  isValidating: boolean;
  setAuth: (admin: Admin, token: string) => void;
  logout: () => void;
  initAuth: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  admin: null,
  token: null,
  isAuthenticated: false,
  isValidating: false,

  setAuth: (admin, token) => {
    localStorage.setItem('admin', JSON.stringify(admin));
    localStorage.setItem('auth_token', token);
    set({ admin, token, isAuthenticated: true });
  },

  logout: () => {
    localStorage.removeItem('admin');
    localStorage.removeItem('auth_token');
    set({ admin: null, token: null, isAuthenticated: false });
  },

  // PERFORMANCE FIX: Validate token on app initialization
  initAuth: async () => {
    const storedAdmin = localStorage.getItem('admin');
    const storedToken = localStorage.getItem('auth_token');

    if (storedAdmin && storedToken) {
      try {
        const admin = JSON.parse(storedAdmin);
        // Temporarily set auth state
        set({ admin, token: storedToken, isAuthenticated: true, isValidating: true });

        // Validate token with server
        try {
          const response = await apiService.getMe();
          // Token is valid, update with fresh admin data
          set({
            admin: response.data?.admin || admin,
            token: storedToken,
            isAuthenticated: true,
            isValidating: false
          });
        } catch (error) {
          // Token is invalid, clear auth
          console.error('Token validation failed:', error);
          localStorage.removeItem('admin');
          localStorage.removeItem('auth_token');
          set({ admin: null, token: null, isAuthenticated: false, isValidating: false });
        }
      } catch (error) {
        // Invalid JSON in storage
        localStorage.removeItem('admin');
        localStorage.removeItem('auth_token');
        set({ isValidating: false });
      }
    } else {
      set({ isValidating: false });
    }
  },
}));
